// 🙈 Coordonnées masquées dans les textes d'un prof (présentation, à propos du cours) : numéros de téléphone,
// adresses web et e-mails remplacés par « ***** ». Même règle que la fiche servie par l'API (tour 59,
// acadeclic-api/app/helper/FicheProf.js, comparée par src/helper/ficheServeur.test.js). Texte absent :
// rendu tel quel.
const PHONE = /\b(\+?\d{1,4}[\s\-.]?)?(\(?\d{1,4}\)?[\s\-.]?)?[\d.\s\-*]{6,15}\b/g;
const URL = /\b(?:https?:\/\/|www\.)\S+\b/g;
const EMAIL = /\b(?:mailto:)?([A-Za-z0-9._%+-]+(?:[\s[]*at[\s\]]*|\s*\(\s*at\s*\)|\s*at\s*)?@[\w.-]+(?:[.,][A-Za-z]{2,})?)\b/g;
const EMAIL_SPACES = /\b(?:mailto:)?[A-Za-z0-9._%+-]+\s?@\s?[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b/g;
const EMAIL_AT = /\b(?:mailto:)?[A-Za-z0-9._%+-]+\s*(?:\[\s*at\s*\]|\s*at\s*)\s?[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b/g;
const EMAIL_PARENTHESES = /\b(?:mailto:)?[A-Za-z0-9._%+-]+\s?\(\s*at\s*\)\s?[A-Za-z0-9.-]+\.[A-Za-z]{2,}\b/g;

export const maskContacts = (text) =>
  text
    ?.replace(PHONE, "*****")
    ?.replace(URL, "*****")
    ?.replace(EMAIL, "*****")
    ?.replace(EMAIL_SPACES, "*****")
    ?.replace(EMAIL_AT, "*****")
    ?.replace(EMAIL_PARENTHESES, "*****");
